import { createContext } from 'react';
import { BoxVariant, Level } from './types';

interface BoxContextType {
  variant: BoxVariant;
  level: Level;
  isGrid: boolean;
}

export const BoxContext = createContext<BoxContextType>({
  variant: 'background',
  level: 0,
  isGrid: false,
});
